import styled from 'styled-components';

export const Container = styled.main`
  @media ${({ theme }) => theme.device.mobile} {
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }
`;

export const Body = styled.section`
  padding: 32px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Divider = styled.div`
  margin: 32px 0;
  width: 100%;
  height: 1px;
  border: solid 1px ${({ theme }) => theme.airlineException.divider};
`;

export const Info = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.airlineException.textColor};
`;

export const Button = styled.button`
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 3.5;
  text-align: center;
  color: ${({ theme }) => theme.airlineException.textButtonColor};
  cursor: pointer;
`;
